// enums/LocalTrips/LocalTripsTypes.js

export const GET_LOCAL_TRIPS_LIST = "GET_LOCAL_TRIPS_LIST";
export const CLEAR_LOCAL_TRIPS_LIST = "CLEAR_LOCAL_TRIPS_LIST";

export const GET_LOCAL_TRIP_DETAIL = "GET_LOCAL_TRIP_DETAIL";
export const CLEAR_LOCAL_TRIP_DETAIL = "CLEAR_LOCAL_TRIP_DETAIL";

export const CREATE_LOCAL_TRIP = "CREATE_LOCAL_TRIP";
export const CLEAR_CREATE_LOCAL_TRIP = "CLEAR_CREATE_LOCAL_TRIP";

export const GET_LOCAL_TRIP_REASONS = "GET_LOCAL_TRIP_REASONS";
export const CLEAR_LOCAL_TRIP_REASONS = "CLEAR_LOCAL_TRIP_REASONS";

export const GET_LOCAL_TRIP_DECISIONS = "GET_LOCAL_TRIP_DECISIONS";
export const CLEAR_LOCAL_TRIP_DECISIONS = "CLEAR_LOCAL_TRIP_DECISIONS";

export const CANCEL_LOCAL_TRIP = "CANCEL_LOCAL_TRIP";
export const CLEAR_CANCEL_LOCAL_TRIP = "CLEAR_CANCEL_LOCAL_TRIP";

export const APPROVE_LOCAL_TRIP = "APPROVE_LOCAL_TRIP";
export const CLEAR_APPROVE_LOCAL_TRIP = "CLEAR_APPROVE_LOCAL_TRIP";

export const GET_ERROR_LOCAL_TRIP = "GET_ERROR_LOCAL_TRIP";
export const CLEAR_ERROR_LOCAL_TRIP = "CLEAR_ERROR_LOCAL_TRIP";

export const CLEAR_CREATED_LOCAL_TRIP = "CLEAR_CREATED_LOCAL_TRIP";
